import ESTIMATE_CONSTANT from "../../../constant/estimateConstant"
import getNumberOfLayers from "../../../service/getNumberOfLayers"
import { isMultiLayer } from "../../../service/oneClickIs"
import type EstimateValues from "../../../types/params"

const isValidBuildUpMethod = (values: EstimateValues, buildUpMethod?: string) => {
  const numberOfLayers = getNumberOfLayers(values)

  switch (buildUpMethod) {
    case ESTIMATE_CONSTANT.ビルドアップ工法["なし(4層)"].value:
    case ESTIMATE_CONSTANT.ビルドアップ工法["1-2-1 BHなし"].value:
    case ESTIMATE_CONSTANT.ビルドアップ工法["1-2-1 BHあり スタガード"].value:
    case ESTIMATE_CONSTANT.ビルドアップ工法["1-2-1 BHあり スタック"].value:
    case ESTIMATE_CONSTANT.ビルドアップ工法["その他の構成(4層)"].value:
      return numberOfLayers === 4
    case ESTIMATE_CONSTANT.ビルドアップ工法["なし(6層)"].value:
    case ESTIMATE_CONSTANT.ビルドアップ工法["1-4-1 BHなし"].value:
    case ESTIMATE_CONSTANT.ビルドアップ工法["1-4-1 BHあり"].value:
    case ESTIMATE_CONSTANT.ビルドアップ工法["2-2-2 BHなし"].value:
    case ESTIMATE_CONSTANT.ビルドアップ工法["2-2-2 スタック"].value:
    case ESTIMATE_CONSTANT.ビルドアップ工法["2-2-2 BHあり スタガード"].value:
    case ESTIMATE_CONSTANT.ビルドアップ工法["2-2-2 BHあり フルスタック"].value:
    case ESTIMATE_CONSTANT.ビルドアップ工法["その他の構成(6層)"].value:
      return numberOfLayers === 6
    case ESTIMATE_CONSTANT.ビルドアップ工法["なし(8層)"].value:
    case ESTIMATE_CONSTANT.ビルドアップ工法["1-6-1 BHなし"].value:
    case ESTIMATE_CONSTANT.ビルドアップ工法["2-4-2 BHなし"].value:
    case ESTIMATE_CONSTANT.ビルドアップ工法["2-4-2 BHなし スタック"].value:
    case ESTIMATE_CONSTANT.ビルドアップ工法["2-4-2 BHあり スタガード"].value:
    case ESTIMATE_CONSTANT.ビルドアップ工法["2-4-2 BHあり フルスタック"].value:
    case ESTIMATE_CONSTANT.ビルドアップ工法["3-2-3 BHなし スタガード"].value:
    case ESTIMATE_CONSTANT.ビルドアップ工法["3-2-3 BHなし スタック"].value:
    case ESTIMATE_CONSTANT.ビルドアップ工法["3-2-3 BHあり フルスタック"].value:
    case ESTIMATE_CONSTANT.ビルドアップ工法["その他の構成(8層)"].value:
      return numberOfLayers === 8
    case ESTIMATE_CONSTANT.ビルドアップ工法["なし(10層)"].value:
    case ESTIMATE_CONSTANT.ビルドアップ工法["1-8-1"].value:
    case ESTIMATE_CONSTANT.ビルドアップ工法["2-6-2"].value:
    case ESTIMATE_CONSTANT.ビルドアップ工法["3-4-3"].value:
    case ESTIMATE_CONSTANT.ビルドアップ工法["その他の構成(10層)"].value:
      return numberOfLayers === 10
    case ESTIMATE_CONSTANT.ビルドアップ工法["なし(12層)"].value:
    case ESTIMATE_CONSTANT.ビルドアップ工法["1-10-1"].value:
    case ESTIMATE_CONSTANT.ビルドアップ工法["2-8-2"].value:
    case ESTIMATE_CONSTANT.ビルドアップ工法["3-6-3"].value:
    case ESTIMATE_CONSTANT.ビルドアップ工法["4-4-4"].value:
    case ESTIMATE_CONSTANT.ビルドアップ工法["その他の構成(12層)"].value:
      return numberOfLayers === 12
    case ESTIMATE_CONSTANT.ビルドアップ工法["なし(片面2層)"].value:
      return !isMultiLayer(values)
    default:
      return false
  }
}

export default isValidBuildUpMethod
